import Api from '../../shared/Api';
import ISe360User from './ISe360User';
import IRole from './IRole';

class Se360UsersApi {
    static list(): Promise<any> {
        return new Promise<any>(
            (resolve: (response: ISe360User[]) => void, reject: (error: string) => void) => {
                new Api()
                    .get('/views/se360users')
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static new(): Promise<any> {
        return new Promise<any>(
            (resolve: (response: IRole[]) => void, reject: (error: string) => void) => {
                new Api()
                    .get('/views/se360users/new')
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static create(user: ISe360User): Promise<any> {
        return new Promise<any>(
            (resolve: (results: any[]) => void, reject: (errors: string[]) => void) => {
                new Api()
                    .post('/views/se360users', user)
                    .then((results: any[]) => {
                        resolve(results);
                    })
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static edit(id: number): Promise<any> {
        return new Promise<any>(
            (resolve: (response: IRole[]) => void, reject: (error: string) => void) => {
                new Api()
                    .get(`/views/se360users/${id}/edit`)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static update(id: number, input: any): Promise<any> {
        // TODO: this is temporary solution that should be removed after the modal will have Firstname and Lastname instead of Firstname and Lastname the Name
        const words = input.name.split(/\s+/);
        if (words.length === 1) {
            input.firstname = words[0];
            input.lastname = '';
        } else if (words.length >= 2) {
            input.firstname = words.slice(0, -1).join(' ');
            input.lastname = words[words.length - 1];
        }

        return new Promise<any>(
            (resolve: (results: any[]) => void, reject: (errors: string[]) => void) => {
                new Api()
                    .put(`/views/se360users/${id}`, input)
                    .then((results: any[]) => {
                        resolve(results);
                    })
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static delete(id: number): Promise<any> {
        return new Promise<any>(
            (resolve: (response: any) => void, reject: (error: string) => void) => {
                new Api()
                    .delete(`/views/se360users/${id}`)
                    .then((response: any) => {
                        resolve(response);
                    })
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static restore(id: number): Promise<any> {
        return new Promise<any>(
            (resolve: (response: any) => void, reject: (error: string) => void) => {
                new Api()
                    .post(`/views/se360users/${id}/restore`, {})
                    .then((response: any) => {
                        resolve(response);
                    })
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }
}

export default Se360UsersApi;
